<template lang="pug">
  .activity-detail
    Modal(:show="show"
          :modalClass="[$style.responsive]")
      template(slot="header")
        .row.align-items-center.header-row
          .col-1.sync-col
            .sync-logo.pb-2
              img(src="@/assets/img/sync.svg"
                  :class="{'spinning': true}")
          .col
            h2 Activity Detail
          .col-1
            div.close-button.ml-auto(aria-label="Close" @click.prevent="$emit('closeDetail')")
              img(src="@/assets/img/close.svg")
      template(slot="body")
        .row.mt-3
          .col-sm-12.col-md
            h4 {{ transactionDetail.lastName }}, {{ transactionDetail.firstName }}
            table.body-3.detail-table
              tr
                td Date of Birth:
                td.h6 {{ transactionDetail.birthDt }}
              tr
                td ID Number:
                td.h6  {{ transactionDetail.idNbr }} / {{ transactionDetail.idStateCd }} / {{ idType(transactionDetail.idTypeCd) }}
              tr
                td Address:
                td.h6
                  span  {{ transactionDetail.address1 }}
                  br
                  span(v-show="transactionDetail.address2")  {{ transactionDetail.address2 }}
                  br(v-show="transactionDetail.address2")
                  span  {{ transactionDetail.city }}, {{ transactionDetail.stateCd }} {{ transactionDetail.postalCode }}
          .col-sm-12.col-md-3.text-right
            router-link.btn.btn-primary(
              :to="{name: 'person_summary', params: {id: transactionDetail.subjectSid}}"
              target="_blank"
            ) Person Summary
        .row.mt-4
          .col
            h5 Transaction Detail
        .row
          .col
            Datatable.overflow(:column-count="8"
                      :footer="false"
                      :entries="[ transactionDetail ]"
                      tableWidth="700px")
              template(slot="header")
                th.h7
                  div Transaction ID(s)
                  div (N)PLEx
                  div (S)tore
                th.h7 Transaction Date
                th.h7 Activity Type
                th.h7 Product(s)
                th.h7 Grams
                th.h7 Box(es)
                th.h7 Compliance Fail Type
                th.h7 Pharmacy
              template(slot-scope="props")
                tr
                  td.body-3
                    div (N) {{ props.entry.transactionSid }}
                    div (S) {{ props.entry.pharmacyTrxId || 'N/A' }}
                  td.body-3 {{ props.entry.transactionDt }}
                  td.body-3 {{ props.entry.transactionCd }}
                  td.body-3
                    div(v-for="product of props.entry.productDesc" :key="product") {{ product }}
                  td.body-3 {{ props.entry.grams }}
                  td.body-3 {{ props.entry.boxes }}
                  td.body-3(v-html="complianceFailType")
                  td.body-3
                    div {{ props.entry.pharmacyName }}
                    div {{ props.entry.pharmacyPhone }}
                    div {{ props.entry.pharmacyAddress1 }}
                    div {{ props.entry.pharmacyAddress2 }}
                    div {{ props.entry.pharmacyCity }}, {{ props.entry.pharmacyStateCd }} {{ props.entry.pharmacyPostalCode }}
                tr.bg-white(v-if="imageLink")
                  td(colspan="8")
                    img.signature(
                      :src="imageLink"
                    )
        .row.mt-4
          .col
            h5 Purchaser Transaction Summary For The Last Year
        .row
          .col
            Datatable(:columns="['All Activity', 'Purchases', 'Blocks', 'Exceedances', 'Returns']"
                      :entries='[lastYearTotals]'
                      :footer="false")
              template(slot-scope="props")
                tr
                  td.body-3 {{ allTotal }}
                  td.body-3 {{ purchaseTotal }}
                  td.body-3 {{ blockTotal }}
                  td.body-3 {{ exceedanceTotal }}
                  td.body-3 {{ returnTotal }}
</template>

<script>
import Modal from './Modal'
import Datatable from './Datatable'
import axios from '@/lib/axios'
import { idType } from '@/lib/utils'

export default {
  name: 'StoreFeedActivityModal',
  data: function() {
    return {
      transactionDetail: {},
      lastYearTotals: [],
      imageLink: '',
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    transactionId: {
      type: [Number, String],
      default: -1,
    },
  },
  methods: { idType },
  computed: {
    allTotal() {
      return (
        this.purchaseTotal +
        this.blockTotal +
        this.exceedanceTotal +
        this.returnTotal
      )
    },
    purchaseTotal() {
      return (
        (this.lastYearTotals.find(a => a.transactionCd === 'Purchase') || {})
          .count || 0
      )
    },
    blockTotal() {
      return (
        (this.lastYearTotals.find(a => a.transactionCd === 'Block') || {})
          .count || 0
      )
    },
    exceedanceTotal() {
      return (
        (this.lastYearTotals.find(a => a.transactionCd === 'Exceedance') || {})
          .count || 0
      )
    },
    returnTotal() {
      return (
        (this.lastYearTotals.find(a => a.transactionCd === 'Return') || {})
          .count || 0
      )
    },
    complianceFailType() {
      let out = ''
      let cft = this.transactionDetail.complianceFailType || {}
      for (let agentDesc in cft) {
        out =
          out +
          `<strong>${agentDesc}:</strong> ${cft[agentDesc].join(', ')}<br/>`
      }
      return out
    },
  },
  watch: {
    transactionId(val) {
      if (val === -1) return
      axios()
        .get('/api/store_feed/detail1', { params: { sid: val } })
        .then(resp => {
          this.transactionDetail = resp.data[0] || {}
          let detail = resp.data[0]
          if (detail.imageName) {
            axios()
              .get('/api/misc/signature', {
                params: { path: encodeURIComponent(detail.imageName) },
              })
              .then(resp => (this.imageLink = resp.data.url))
          }
        })
      axios()
        .get('/api/store_feed/detail2', { params: { sid: val } })
        .then(resp => (this.lastYearTotals = resp.data || []))
    },
  },
  components: {
    Modal,
    Datatable,
  },
}
</script>

<style lang="scss" scoped>
.detail-table {
  tr {
    td {
      vertical-align: top;
    }
  }
}
.close-button {
  width: 2rem;
  cursor: pointer;
}

.header-row {
  height: 4rem;
}

.bg-white {
  background: white;
  border-top: 1px solid #d8d8d8;
}

.overflow {
  overflow-x: auto;
}

.spinning {
  animation: spinning 3s linear infinite;
}

@keyframes spinning {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.sync-logo {
  width: 2rem;
}

.sync-col {
  padding-right: 0;
}

.signature {
  width: 100%;
  height: 3rem;
  border: 1px solid #d8d8d8;
  padding: 0.2rem;
}
</style>

<style lang="scss" module>
@import '../assets/styles/breakpoints';

.responsive {
  width: 70% !important;
  height: 85% !important;

  @media (max-width: $bp-md) {
    width: 90% !important;
  }
}
</style>
